import * as i4 from '@angular/cdk/overlay';
import { CdkConnectedOverlay, OverlayModule } from '@angular/cdk/overlay';
import * as i0 from '@angular/core';
import { EventEmitter, TemplateRef, numberAttribute, booleanAttribute, Component, Optional, Self, Attribute, Input, HostBinding, Output, ViewChild, ViewChildren, HostListener, Directive, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as i1 from '@angular/cdk/scrolling';
import * as i2 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from 'ngx-infinite-scroll';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
const _c0 = ["selection"];
const _c1 = ["results"];
const _c2 = ["searchInput"];
const _c3 = ["dropdown"];
const _c4 = ["result"];
const _c5 = [[["select2-label"]], [["select2-hint"]]];
const _c6 = ["select2-label", "select2-hint"];
const _c7 = () => [];
function Select2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
  }
}
function Select2_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\xA0");
    i0.ɵɵelementEnd();
  }
}
function Select2_Conditional_8_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r1.select2Option.label, i0.ɵɵsanitizeHtml);
  }
}
function Select2_Conditional_8_Conditional_2_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Select2_Conditional_8_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_Conditional_8_Conditional_2_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.getTemplate(ctx_r1.select2Option, "option", true))("ngTemplateOutletContext", ctx_r1.select2Option);
  }
}
function Select2_Conditional_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_Conditional_8_Conditional_2_Conditional_0_Template, 1, 1, "span", 19)(1, Select2_Conditional_8_Conditional_2_Conditional_1_Template, 1, 2, "ng-container");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r1.hasTemplate(ctx_r1.select2Option, "option", true) || ctx_r1.noLabelTemplate ? 0 : 1);
  }
}
function Select2_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, Select2_Conditional_8_Conditional_1_Template, 2, 0, "span")(2, Select2_Conditional_8_Conditional_2_Template, 2, 1);
    i0.ɵɵelementStart(3, "span", 18);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", (ctx_r1.select2Option == null ? null : ctx_r1.select2Option.label) || "");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.select2Option ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.select2Option ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("select2-selection__placeholder__option", ctx_r1.option);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.placeholder);
  }
}
function Select2_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵlistener("click", function Select2_Conditional_9_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.reset($event));
    });
    i0.ɵɵtext(1, "\xD7");
    i0.ɵɵelementEnd();
  }
}
function Select2_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
  }
}
function Select2_Conditional_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("select2-selection__placeholder__option", (ctx_r1.select2Options == null ? null : ctx_r1.select2Options.length) > 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.placeholder);
  }
}
function Select2_Conditional_11_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵlistener("click", function Select2_Conditional_11_For_3_Conditional_1_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const op_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.removeSelection($event, op_r5));
    });
    i0.ɵɵtext(1, "\xD7");
    i0.ɵɵelementEnd();
  }
}
function Select2_Conditional_11_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 19);
  }
  if (rf & 2) {
    const op_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", op_r5.label, i0.ɵɵsanitizeHtml);
  }
}
function Select2_Conditional_11_For_3_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Select2_Conditional_11_For_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_Conditional_11_For_3_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 20);
  }
  if (rf & 2) {
    const op_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.getTemplate(op_r5, "option", true))("ngTemplateOutletContext", op_r5);
  }
}
function Select2_Conditional_11_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 25);
    i0.ɵɵlistener("keydown.enter", function Select2_Conditional_11_For_3_Template_li_keydown_enter_0_listener($event) {
      const op_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.removeSelection($event, op_r5));
    });
    i0.ɵɵtemplate(1, Select2_Conditional_11_For_3_Conditional_1_Template, 2, 0, "span", 26)(2, Select2_Conditional_11_For_3_Conditional_2_Template, 1, 1, "span", 19)(3, Select2_Conditional_11_For_3_Conditional_3_Template, 1, 2, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const op_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", op_r5.label);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ctx_r1.disabled || ctx_r1.readonly) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.hasTemplate(op_r5, "option", true) || ctx_r1.noLabelTemplate ? 2 : 3);
  }
}
function Select2_Conditional_11_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 28);
    i0.ɵɵlistener("focus", function Select2_Conditional_11_Conditional_4_Template_li_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.stopEvent($event));
    })("blur", function Select2_Conditional_11_Conditional_4_Template_li_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.stopEvent($event));
    });
    i0.ɵɵelementStart(1, "input", 29);
    i0.ɵɵlistener("click", function Select2_Conditional_11_Conditional_4_Template_input_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.toggleOpenAndClose(false, true);
      return i0.ɵɵresetView(ctx_r1.stopEvent($event));
    })("keydown", function Select2_Conditional_11_Conditional_4_Template_input_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.keyDown($event, true));
    })("keyup", function Select2_Conditional_11_Conditional_4_Template_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.searchUpdate($event));
    })("change", function Select2_Conditional_11_Conditional_4_Template_input_change_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.prevChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id + "-create-field");
  }
}
function Select2_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 15);
    i0.ɵɵtemplate(1, Select2_Conditional_11_Conditional_1_Template, 2, 3, "span", 22);
    i0.ɵɵrepeaterCreate(2, Select2_Conditional_11_For_3_Template, 4, 3, "li", 23, i0.ɵɵcomponentInstance().trackBy, true);
    i0.ɵɵtemplate(4, Select2_Conditional_11_Conditional_4_Template, 2, 1, "li", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.autoCreate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.option || i0.ɵɵpureFunction0(2, _c7));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.autoCreate ? 4 : -1);
  }
}
function Select2_Conditional_12_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Select2_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_Conditional_12_ng_container_0_Template, 1, 0, "ng-container", 30);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const containerTemplate_r8 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", containerTemplate_r8);
  }
}
function Select2_ng_template_15_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Select2_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_ng_template_15_ng_container_0_Template, 1, 0, "ng-container", 30);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const containerTemplate_r8 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", containerTemplate_r8);
  }
}
function Select2_ng_template_16_For_10_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "strong", 19);
  }
  if (rf & 2) {
    const groupOrOption_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", groupOrOption_r10.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("class", "select2-results__group" + (groupOrOption_r10.classes ? " " + groupOrOption_r10.classes : ""));
  }
}
function Select2_ng_template_16_For_10_Conditional_0_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Select2_ng_template_16_For_10_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_ng_template_16_For_10_Conditional_0_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 20);
  }
  if (rf & 2) {
    const groupOrOption_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.getTemplate(groupOrOption_r10, "group"))("ngTemplateOutletContext", groupOrOption_r10);
  }
}
function Select2_ng_template_16_For_10_Conditional_0_For_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 43);
  }
  if (rf & 2) {
    const option_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", option_r12.label, i0.ɵɵsanitizeHtml);
  }
}
function Select2_ng_template_16_For_10_Conditional_0_For_5_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Select2_ng_template_16_For_10_Conditional_0_For_5_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_ng_template_16_For_10_Conditional_0_For_5_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 20);
  }
  if (rf & 2) {
    const option_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.getTemplate(option_r12, "option"))("ngTemplateOutletContext", option_r12);
  }
}
function Select2_ng_template_16_For_10_Conditional_0_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 42, 5);
    i0.ɵɵlistener("mouseenter", function Select2_ng_template_16_For_10_Conditional_0_For_5_Template_li_mouseenter_0_listener() {
      const option_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.mouseenter(option_r12));
    })("click", function Select2_ng_template_16_For_10_Conditional_0_For_5_Template_li_click_0_listener() {
      const option_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.click(option_r12));
    });
    i0.ɵɵtemplate(2, Select2_ng_template_16_For_10_Conditional_0_For_5_Conditional_2_Template, 1, 1, "div", 43)(3, Select2_ng_template_16_For_10_Conditional_0_For_5_Conditional_3_Template, 1, 2, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r12 = ctx.$implicit;
    const ɵ$index_108_r13 = ctx.$index;
    const ɵ$index_94_r14 = i0.ɵɵnextContext(2).$index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.getOptionStyle(option_r12));
    i0.ɵɵproperty("id", option_r12.id || ctx_r1.id + "-option-" + ɵ$index_94_r14 + "-" + ɵ$index_108_r13);
    i0.ɵɵattribute("aria-selected", ctx_r1.isSelected(option_r12))("aria-disabled", ctx_r1.isDisabled(option_r12));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.hasTemplate(option_r12, "option") ? 2 : 3);
  }
}
function Select2_ng_template_16_For_10_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 39);
    i0.ɵɵtemplate(1, Select2_ng_template_16_For_10_Conditional_0_Conditional_1_Template, 1, 2, "strong", 19)(2, Select2_ng_template_16_For_10_Conditional_0_Conditional_2_Template, 1, 2, "ng-container");
    i0.ɵɵelementStart(3, "ul", 41);
    i0.ɵɵrepeaterCreate(4, Select2_ng_template_16_For_10_Conditional_0_For_5_Template, 4, 6, "li", 40, i0.ɵɵcomponentInstance().trackBy, true);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const groupOrOption_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.hasTemplate(groupOrOption_r10, "group") ? 1 : 2);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(groupOrOption_r10.options);
  }
}
function Select2_ng_template_16_For_10_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 43);
  }
  if (rf & 2) {
    const groupOrOption_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", groupOrOption_r10.label, i0.ɵɵsanitizeHtml);
  }
}
function Select2_ng_template_16_For_10_Conditional_1_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Select2_ng_template_16_For_10_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_ng_template_16_For_10_Conditional_1_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 20);
  }
  if (rf & 2) {
    const groupOrOption_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.getTemplate(groupOrOption_r10, "option"))("ngTemplateOutletContext", groupOrOption_r10);
  }
}
function Select2_ng_template_16_For_10_Conditional_1_ng_template_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Select2_ng_template_16_For_10_Conditional_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_ng_template_16_For_10_Conditional_1_ng_template_4_ng_container_0_Template, 1, 0, "ng-container", 20);
  }
  if (rf & 2) {
    const groupOrOption_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.getTemplate(groupOrOption_r10, "option"))("ngTemplateOutletContext", groupOrOption_r10);
  }
}
function Select2_ng_template_16_For_10_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 42, 5);
    i0.ɵɵlistener("mouseenter", function Select2_ng_template_16_For_10_Conditional_1_Template_li_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const groupOrOption_r10 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.mouseenter(groupOrOption_r10));
    })("click", function Select2_ng_template_16_For_10_Conditional_1_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const groupOrOption_r10 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.click(groupOrOption_r10));
    });
    i0.ɵɵtemplate(2, Select2_ng_template_16_For_10_Conditional_1_Conditional_2_Template, 1, 1, "div", 43)(3, Select2_ng_template_16_For_10_Conditional_1_Conditional_3_Template, 1, 2, "ng-container")(4, Select2_ng_template_16_For_10_Conditional_1_ng_template_4_Template, 1, 2, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    const groupOrOption_r10 = ctx_r15.$implicit;
    const ɵ$index_94_r14 = ctx_r15.$index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.getOptionStyle(groupOrOption_r10));
    i0.ɵɵproperty("id", groupOrOption_r10.id || ctx_r1.id + "-option-" + ɵ$index_94_r14);
    i0.ɵɵattribute("aria-selected", ctx_r1.isSelected(groupOrOption_r10))("aria-disabled", ctx_r1.isDisabled(groupOrOption_r10));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.hasTemplate(groupOrOption_r10, "option") ? 2 : 3);
  }
}
function Select2_ng_template_16_For_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Select2_ng_template_16_For_10_Conditional_0_Template, 6, 1, "li", 39)(1, Select2_ng_template_16_For_10_Conditional_1_Template, 6, 6, "li", 40);
  }
  if (rf & 2) {
    const groupOrOption_r10 = ctx.$implicit;
    i0.ɵɵconditional(groupOrOption_r10.options !== undefined ? 0 : 1);
  }
}
function Select2_ng_template_16_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.noResultMessage, i0.ɵɵsanitizeHtml);
  }
}
function Select2_ng_template_16_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 38);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.maxResultsMessage, i0.ɵɵsanitizeHtml);
  }
}
function Select2_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "div", 32, 2)(3, "div", 33)(4, "input", 34, 3);
    i0.ɵɵlistener("keydown", function Select2_ng_template_16_Template_input_keydown_4_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keyDown($event, ctx_r1.autoCreate));
    })("keyup", function Select2_ng_template_16_Template_input_keyup_4_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.searchUpdate($event));
    })("change", function Select2_ng_template_16_Template_input_change_4_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.prevChange($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 35)(7, "ul", 36, 4);
    i0.ɵɵlistener("scrolled", function Select2_ng_template_16_Template_ul_scrolled_7_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onScroll("down"));
    })("scrolledUp", function Select2_ng_template_16_Template_ul_scrolledUp_7_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onScroll("up"));
    })("keydown", function Select2_ng_template_16_Template_ul_keydown_7_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keyDown($event));
    });
    i0.ɵɵrepeaterCreate(9, Select2_ng_template_16_For_10_Template, 2, 1, null, null, i0.ɵɵcomponentInstance().trackBy, true);
    i0.ɵɵtemplate(11, Select2_ng_template_16_Conditional_11_Template, 1, 1, "li", 37)(12, Select2_ng_template_16_Conditional_12_Template, 1, 1, "li", 38);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const results_r17 = i0.ɵɵreference(8);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("select2-container--open", ctx_r1.isOpen)("select2-overlay", ctx_r1.overlay)("select2-position-auto", ctx_r1.listPosition === "auto")("select2-style-borderless", ctx_r1.styleMode === "borderless");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("select2-dropdown--below", !ctx_r1.select2above)("select2-dropdown--above", ctx_r1.select2above);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("select2-search--hide", ctx_r1.hideSearch());
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id + "-search-field")("value", ctx_r1.searchText);
    i0.ɵɵattribute("tabindex", ctx_r1.isOpen ? ctx_r1.tabIndex : "-1");
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("max-height", ctx_r1.resultMaxHeight)("--grid-size", ctx_r1.grid || null);
    i0.ɵɵclassProp("select2-grid", ctx_r1.grid && ctx_r1.isNumber(ctx_r1.grid))("select2-grid-auto", ctx_r1.grid && !ctx_r1.isNumber(ctx_r1.grid));
    i0.ɵɵproperty("infiniteScrollDisabled", !ctx_r1.infiniteScroll && !ctx_r1.isOpen)("infiniteScrollDistance", ctx_r1.infiniteScrollDistance)("infiniteScrollThrottle", ctx_r1.infiniteScrollThrottle)("infiniteScrollContainer", results_r17);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.filteredData);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!(ctx_r1.filteredData == null ? null : ctx_r1.filteredData.length) && ctx_r1.noResultMessage ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.maxResultsExceeded ? 12 : -1);
  }
}
const timeout = 200;
const unicodePatterns = [{
  l: 'a',
  s: /[ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ]/gi
}, {
  l: 'aa',
  s: /ꜳ/gi
}, {
  l: 'ae',
  s: /[æǽǣ]/gi
}, {
  l: 'ao',
  s: /ꜵ/gi
}, {
  l: 'au',
  s: /ꜷ/gi
}, {
  l: 'av',
  s: /[ꜹꜻ]/gi
}, {
  l: 'ay',
  s: /ꜽ/gi
}, {
  l: 'b',
  s: /[ⓑｂḃḅḇƀƃɓ]/gi
}, {
  l: 'c',
  s: /[ⓒｃćĉċčçḉƈȼꜿↄ]/gi
}, {
  l: 'd',
  s: /[ⓓｄḋďḍḑḓḏđƌɖɗꝺ]/gi
}, {
  l: 'dz',
  s: /[ǳǆ]/gi
}, {
  l: 'e',
  s: /[ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ]/gi
}, {
  l: 'f',
  s: /[ⓕｆḟƒꝼ]/gi
}, {
  l: 'g',
  s: /[ⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ]/gi
}, {
  l: 'h',
  s: /[ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ]/gi
}, {
  l: 'hv',
  s: /ƕ/gi
}, {
  l: 'i',
  s: /[ⓘｉìíîĩīĭİïḯỉǐȉȋịįḭɨı]/gi
}, {
  l: 'j',
  s: /[ⓙｊĵǰɉ]/gi
}, {
  l: 'k',
  s: /[ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ]/gi
}, {
  l: 'l',
  s: /[ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇꝆ]/gi
}, {
  l: 'lj',
  s: /ǉ/gi
}, {
  l: 'm',
  s: /[ⓜｍḿṁṃɱɯ]/gi
}, {
  l: 'n',
  s: /[ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ]/gi
}, {
  l: 'nj',
  s: /ǌ/gi
}, {
  l: 'o',
  s: /[ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔƟꝋꝍɵ]/gi
}, {
  l: 'oi',
  s: /ƣ/gi
}, {
  l: 'oe',
  s: /œ/gi
}, {
  l: 'oo',
  s: /ꝏ/gi
}, {
  l: 'ou',
  s: /ȣ/gi
}, {
  l: 'p',
  s: /[ⓟｐṕṗƥᵽꝑꝓꝕ]/gi
}, {
  l: 'q',
  s: /[ⓠｑɋꝗꝙ]/gi
}, {
  l: 'r',
  s: /[ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ]/gi
}, {
  l: 's',
  s: /[ⓢｓßẞśṥŝṡšṧṣṩșşȿꞩꞅẛ]/gi
}, {
  l: 't',
  s: /[ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ]/gi
}, {
  l: 'tz',
  s: /ꜩ/gi
}, {
  l: 'u',
  s: /[ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ]/gi
}, {
  l: 'v',
  s: /[ⓥｖṽṿʋꝟʌ]/gi
}, {
  l: 'vy',
  s: /ꝡ/gi
}, {
  l: 'w',
  s: /[ⓦｗẁẃŵẇẅẘẉⱳ]/gi
}, {
  l: 'x',
  s: /[ⓧｘẋẍ]/gi
}, {
  l: 'y',
  s: /[ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ]/gi
}, {
  l: 'z',
  s: /[ⓩｚźẑżžẓẕƶȥɀⱬꝣ]/gi
}];
const defaultMinCountForSearch = 6;
const protectRegexp = new RegExp('[\\-\\[\\]\\/\\{\\}\\(\\)\\*\\+\\?\\.\\\\\\^\\$\\|]', 'g');
class Select2Utils {
  static getOptionByValue(data, value) {
    if (Array.isArray(data)) {
      for (const groupOrOption of data) {
        const options = groupOrOption.options;
        if (options) {
          for (const option of options) {
            if (option.value === value) {
              return option;
            }
          }
        } else if (groupOrOption.value === value) {
          return groupOrOption;
        }
      }
    }
    return undefined;
  }
  static getOptionsByValue(data, value, multiple) {
    if (multiple) {
      const values = Array.isArray(value) ? value : [];
      const result = [];
      for (const v of values) {
        const option = Select2Utils.getOptionByValue(data, v);
        if (option) {
          result.push(option);
        }
      }
      return result;
    }
    return Select2Utils.getOptionByValue(data, value);
  }
  static getFirstAvailableOption(data) {
    if (Array.isArray(data)) {
      for (const groupOrOption of data) {
        const options = groupOrOption.options;
        if (options) {
          for (const option of options) {
            if (!option.disabled) {
              return option.value;
            }
          }
        } else {
          const option = groupOrOption;
          if (!option.disabled) {
            return option.value;
          }
        }
      }
    }
    return null;
  }
  static valueIsNotInFilteredData(filteredData, value) {
    if (Select2Utils.isNullOrUndefined(value)) {
      return true;
    }
    for (const groupOrOption of filteredData) {
      const options = groupOrOption.options;
      if (options) {
        for (const option of options) {
          if (option.value === value) {
            return false;
          }
        }
      } else if (groupOrOption.value === value) {
        return false;
      }
    }
    return true;
  }
  static getPreviousOption(filteredData, hoveringValue) {
    let findIt = Select2Utils.isNullOrUndefined(hoveringValue);
    for (let i = filteredData.length - 1; i >= 0; i--) {
      const groupOrOption = filteredData[i];
      const options = groupOrOption.options;
      if (options) {
        for (let j = options.length - 1; j >= 0; j--) {
          const option = options[j];
          if (findIt && !option.disabled && !option.hide) {
            return option;
          }
          if (!findIt) {
            findIt = option.value === hoveringValue;
          }
        }
      } else {
        const option = groupOrOption;
        if (findIt && !option.disabled && !option.hide) {
          return option;
        }
        if (!findIt) {
          findIt = option.value === hoveringValue;
        }
      }
    }
    return null;
  }
  static getNextOption(filteredData, hoveringValue) {
    let findIt = Select2Utils.isNullOrUndefined(hoveringValue);
    for (const groupOrOption of filteredData) {
      const options = groupOrOption.options;
      if (options) {
        for (const option of options) {
          if (findIt) {
            if (!option.disabled && !option.hide) {
              return option;
            }
          } else if (!findIt) {
            findIt = option.value === hoveringValue;
          }
        }
      } else {
        const option = groupOrOption;
        if (findIt) {
          if (!option.disabled && !option.hide) {
            return option;
          }
        } else if (!findIt) {
          findIt = option.value === hoveringValue;
        }
      }
    }
    return null;
  }
  static getReduceData(data, maxResults = 0) {
    if (maxResults > 0) {
      let counter = 0;
      const result = [];
      // debugger;
      for (const groupOrOption of data) {
        const options = groupOrOption.options;
        if (options) {
          const group = {
            ...groupOrOption,
            options: []
          };
          result.push(group);
          for (const item of options) {
            group.options.push(item);
            counter++;
            if (counter === maxResults) {
              return {
                result,
                reduce: true
              };
            }
          }
        } else {
          result.push(groupOrOption);
          counter++;
        }
        if (counter === maxResults) {
          return {
            result,
            reduce: true
          };
        }
      }
      return {
        result,
        reduce: false
      };
    } else {
      return {
        result: data,
        reduce: false
      };
    }
  }
  static getFilteredData(data, searchText, editPattern) {
    if (searchText) {
      const result = [];
      for (const groupOrOption of data) {
        const options = groupOrOption.options;
        if (options) {
          if (options.some(group => Select2Utils.containSearchText(group.label, searchText, editPattern))) {
            const filteredOptions = options.filter(group => Select2Utils.containSearchText(group.label, searchText, editPattern));
            result.push({
              ...groupOrOption,
              options: filteredOptions
            });
          }
        } else if (Select2Utils.containSearchText(groupOrOption.label, searchText, editPattern)) {
          result.push(groupOrOption);
        }
      }
      return result;
    } else {
      return data;
    }
  }
  static getFilteredSelectedData(data, selectedOptions) {
    const result = [];
    for (const groupOrOption of data) {
      const options = groupOrOption.options;
      if (options) {
        const filteredOptions = options.filter(group => Select2Utils.isSelected(selectedOptions, group, true) === 'false');
        if (filteredOptions.length) {
          result.push({
            ...groupOrOption,
            options: filteredOptions
          });
        }
      } else if (Select2Utils.isSelected(selectedOptions, groupOrOption, true) === 'false') {
        result.push(groupOrOption);
      }
    }
    return result;
  }
  static isSearchboxHiddex(data, minCountForSearch) {
    if (minCountForSearch === '' || minCountForSearch === undefined || minCountForSearch === null || isNaN(+minCountForSearch)) {
      minCountForSearch = defaultMinCountForSearch;
    }
    const optionCount = Select2Utils.getOptionsCount(data);
    return optionCount < +minCountForSearch;
  }
  static isSelected(options, option, multiple) {
    return multiple ? options && options.some(op => op.value === option.value) ? 'true' : 'false' : options && option.value === options.value ? 'true' : 'false';
  }
  static removeSelection(options, option) {
    for (let i = 0; i < options.length; i++) {
      if (options[i].value === option.value) {
        options.splice(i, 1);
        return;
      }
    }
  }
  static getOptionsCount(data) {
    let count = 0;
    if (Array.isArray(data)) {
      for (const groupOrOption of data) {
        const options = groupOrOption.options;
        count += options ? options.length : 1;
      }
    }
    return count;
  }
  static isNullOrUndefined(value) {
    return value === null || value === undefined;
  }
  static containSearchText(label, searchText, editPattern) {
    return searchText ? Select2Utils.formatSansUnicode(label).match(new RegExp(Select2Utils.formatPattern(searchText, editPattern), 'i')) !== null : true;
  }
  static protectPattern(str) {
    return str.replace(protectRegexp, '\\$&');
  }
  static formatSansUnicode(str) {
    for (const unicodePattern of unicodePatterns) {
      str = str.replace(unicodePattern.s, unicodePattern.l);
    }
    return str;
  }
  static formatPattern(str, editPattern) {
    str = Select2Utils.formatSansUnicode(Select2Utils.protectPattern(str));
    if (editPattern && typeof editPattern === 'function') {
      str = editPattern(str);
    }
    return str;
  }
}
let nextUniqueId = 0;
const displaySearchStatusList = ['default', 'hidden', 'always'];
let Select2 = /*#__PURE__*/(() => {
  class Select2 {
    /** data of options & optiongrps */
    set data(data) {
      this._data = data;
      this.updateFilteredData(true);
    }
    get multiple() {
      return this._multiple;
    }
    set multiple(value) {
      this._multiple = value;
      this.ngOnInit();
    }
    /** minimal data of show the search field */
    get minCountForSearch() {
      return this._minCountForSearch;
    }
    set minCountForSearch(value) {
      this._minCountForSearch = value;
      this.updateSearchBox();
    }
    /** Unique id of the element. */
    get id() {
      return this._id;
    }
    set id(value) {
      this._id = value || this._uid;
    }
    /** Whether selected items should be hidden. */
    get disabled() {
      return this._control ? this._control.disabled : this._disabled;
    }
    set disabled(value) {
      this._disabled = value;
    }
    /** The input element's value. */
    get value() {
      return this._value;
    }
    set value(value) {
      if (this.testValueChange(this._value, value)) {
        setTimeout(() => {
          if (this._value === undefined) {
            this._value = value ?? null;
          }
          this.writeValue(value ?? null);
        }, 10);
      }
    }
    /** Tab index for the select2 element. */
    get tabIndex() {
      return this.disabled ? -1 : this._tabIndex;
    }
    set tabIndex(value) {
      this._tabIndex = value;
    }
    get select2Options() {
      return this.multiple ? this.option : null;
    }
    get select2Option() {
      return this.multiple ? null : this.option;
    }
    get searchText() {
      return this.innerSearchText;
    }
    set searchText(text) {
      this.innerSearchText = text;
    }
    get ariaInvalid() {
      return this._isErrorState();
    }
    get classMaterial() {
      return this.styleMode === 'material';
    }
    get classNostyle() {
      return this.styleMode === 'noStyle';
    }
    get classBorderless() {
      return this.styleMode === 'borderless';
    }
    get select2above() {
      return !this.overlay ? this.listPosition === 'above' : this._isAbobeOverlay();
    }
    get _positions() {
      return this.listPosition === 'auto' ? undefined : null;
    }
    get resultsElement() {
      return this.resultContainer?.nativeElement;
    }
    constructor(_viewportRuler, _changeDetectorRef, _parentForm, _parentFormGroup, _control, tabIndex) {
      this._viewportRuler = _viewportRuler;
      this._changeDetectorRef = _changeDetectorRef;
      this._parentForm = _parentForm;
      this._parentFormGroup = _parentFormGroup;
      this._control = _control;
      this.minCharForSearch = 0;
      this.limitSelection = 0;
      this.listPosition = 'below';
      /** use the material style */
      this.overlay = false;
      /** use the material style */
      this.styleMode = 'default';
      /** maximum results limit (0 = no limit) */
      this.maxResults = 0;
      /** message when maximum results */
      this.maxResultsMessage = 'Too many results…';
      /** infinite scroll distance */
      this.infiniteScrollDistance = 1.5;
      /** infinite scroll distance */
      this.infiniteScrollThrottle = 150;
      /** infinite scroll activated */
      this.infiniteScroll = false;
      /** auto create if not exist */
      this.autoCreate = false;
      /** no template for label selection */
      this.noLabelTemplate = false;
      /** the max height of the results container when opening the select */
      this.resultMaxHeight = '200px';
      /** Active Search event */
      this.customSearchEnabled = false;
      /** Whether the element is required. */
      this.required = false;
      /** Whether items are hidden when has. */
      this.hideSelectedItems = false;
      /** Whether the element is readonly. */
      this.readonly = false;
      /** reset with no selected value */
      this.resettable = false;
      /** grid: item by line
       * * 0 = no grid
       * * number = item by line (4)
       * * string = minimal size item (100px)
       */
      this.grid = '';
      this.update = new EventEmitter();
      this.autoCreateItem = new EventEmitter();
      this.open = new EventEmitter();
      this.close = new EventEmitter();
      this.focus = new EventEmitter();
      this.blur = new EventEmitter();
      this.search = new EventEmitter();
      this.scroll = new EventEmitter();
      this.removeOption = new EventEmitter();
      this.option = null;
      this.isOpen = false;
      /** Whether the element is focused or not. */
      this.focused = false;
      this.hoveringValue = null;
      this.innerSearchText = '';
      this._stateChanges = new Subject();
      this._disabled = false;
      this._multiple = false;
      this._uid = `select2-${nextUniqueId++}`;
      this._value = null;
      /** View -> model callback called when select has been touched */
      this._onTouched = () => {
        // do nothing
      };
      /** View -> model callback called when value changes */
      this._onChange = () => {
        // do nothing
      };
      // eslint-disable-next-line no-self-assign
      this.id = this.id;
      this._tabIndex = parseInt(tabIndex, 10) || 0;
      if (this._control) {
        this._control.valueAccessor = this;
      }
    }
    clickDetection(e) {
      if (this.isOpen && focus) {
        const target = e.target;
        if (!this.ifParentContainsClass(target, 'selection')) {
          if (!this.ifParentContainsClass(target, 'select2-dropdown')) {
            this.toggleOpenAndClose();
          }
          if (!this.overlay && !this.ifParentContainsId(target, this._id)) {
            this.clickExit();
          }
        } else if (!this.ifParentContainsId(target, this._id)) {
          this.toggleOpenAndClose();
          this.clickExit();
        }
      } else if (this.focused) {
        const target = e.target;
        this._focus(this.clickOnSelect2Element(target));
      }
    }
    ngOnInit() {
      this._viewportRuler.change(100).subscribe(() => {
        if (this.isOpen) {
          this.triggerRect();
        }
      });
      const option = Select2Utils.getOptionsByValue(this._data, this._control ? this._control.value : this.value, this.multiple);
      if (option !== null) {
        this.option = option;
      }
      if (!Array.isArray(option)) {
        this.hoveringValue = this.value;
      }
      this.updateSearchBox();
    }
    ngAfterViewInit() {
      this.cdkConnectedOverlay.positionChange.subscribe(posChange => {
        if (this.listPosition === 'auto' && posChange.connectionPair?.originY && this._overlayPosition !== posChange.connectionPair.originY) {
          this.triggerRect();
          this._overlayPosition = posChange.connectionPair.originY;
          this._changeDetectorRef.detectChanges();
        }
      });
      this.selectionElement = this.selection.nativeElement;
      this.triggerRect();
    }
    ngDoCheck() {
      this.updateSearchBox();
      this._dirtyCheckNativeValue();
      if (this._triggerRect) {
        if (this.overlayWidth !== this._triggerRect.width) {
          this.overlayWidth = this._triggerRect.width;
        }
        if (this._dropdownRect?.height > 0 && this.overlayHeight !== this._dropdownRect.height) {
          this.overlayHeight = this.listPosition === 'auto' ? this._dropdownRect.height : 0;
        }
      }
    }
    updateSearchBox() {
      const hidden = this.customSearchEnabled ? false : Select2Utils.isSearchboxHiddex(this._data, this._minCountForSearch);
      if (this.isSearchboxHidden !== hidden) {
        this.isSearchboxHidden = hidden;
      }
    }
    hideSearch() {
      const displaySearchStatus = displaySearchStatusList.indexOf(this.displaySearchStatus) > -1 ? this.displaySearchStatus : 'default';
      return displaySearchStatus === 'default' && this.isSearchboxHidden || displaySearchStatus === 'hidden';
    }
    getOptionStyle(option) {
      return 'select2-results__option ' + (option.hide ? 'select2-results__option--hide ' : '') + (option.value === this.hoveringValue ? 'select2-results__option--highlighted ' : '') + (option.classes || '');
    }
    mouseenter(option) {
      if (!option.disabled) {
        this.hoveringValue = option.value;
      }
    }
    click(option) {
      if (this.testSelection(option)) {
        this.select(option);
      }
    }
    reset(event) {
      // const test = Select2Utils.getOptionByValue(this._data, this.resetSelectedValue);
      // debugger;
      this.select(this.resetSelectedValue !== undefined ? Select2Utils.getOptionByValue(this._data, this.resetSelectedValue) ?? null : null);
      if (event) {
        this.stopEvent(event);
      }
    }
    prevChange(event) {
      event.stopPropagation();
    }
    stopEvent(event) {
      event.preventDefault();
      event.stopPropagation();
    }
    toggleOpenAndClose(focus = true, open, event) {
      if (this.disabled) {
        return;
      }
      this._focus(focus);
      const changeEmit = this.isOpen !== (open ?? !this.isOpen);
      this.isOpen = open ?? !this.isOpen;
      if (this.isOpen) {
        if (!this.isSearchboxHidden) {
          this.innerSearchText = '';
          this.updateFilteredData();
          this._focusSearchboxOrResultsElement(focus);
        }
        if (this.isSearchboxHidden && !changeEmit && event) {
          this.keyDown(event);
        } else {
          setTimeout(() => {
            if (this.option) {
              const option = Array.isArray(this.option) ? this.option[0] : this.option;
              this.updateScrollFromOption(option);
            } else if (this.resultsElement) {
              this.resultsElement.scrollTop = 0;
            }
            setTimeout(() => {
              this.triggerRect();
              this.cdkConnectedOverlay?.overlayRef?.updatePosition();
            }, 100);
          });
        }
        if (changeEmit) {
          this.open.emit(this);
        }
      } else if (changeEmit) {
        this.close.emit(this);
      }
      this._changeDetectorRef.markForCheck();
    }
    hasTemplate(option, defaultValue, select = false) {
      return (select ? this.templates?.[option.templateSelectionId] instanceof TemplateRef || this.templates?.[`${defaultValue}Selection`] instanceof TemplateRef || this.templates?.[`templateSelection`] instanceof TemplateRef || this.templateSelection instanceof TemplateRef : false) || this.templates?.[option.templateId] instanceof TemplateRef || this.templates?.[defaultValue] instanceof TemplateRef || this.templates?.['template'] instanceof TemplateRef || this.templates instanceof TemplateRef || false;
    }
    getTemplate(option, defaultValue, select = false) {
      return this.hasTemplate(option, defaultValue, select) ? (select ? this.templates?.[option.templateSelectionId] || this.templates?.[`${defaultValue}Selection`] || this.templates?.[`templateSelection`] || this.templateSelection : undefined) || this.templates?.[option.templateId] || this.templates?.[defaultValue] || this.templates?.['template'] || this.templates : undefined;
    }
    triggerRect() {
      this._triggerRect = this.selectionElement.getBoundingClientRect();
      this._dropdownRect = this.dropdown?.nativeElement ? this.dropdown.nativeElement.getBoundingClientRect() : undefined;
    }
    isNumber(o) {
      return !isNaN(o - 0) && o !== null && o !== '' && o !== false;
    }
    testSelection(option) {
      if (option.disabled) {
        return false;
      }
      return !this.multiple || !this.limitSelection || Array.isArray(this._value) && this._value.length < this.limitSelection;
    }
    testValueChange(value1, value2) {
      if ((value1 === null || value1 === undefined) && (value2 === null || value2 === undefined) || value1 === value2) {
        return false;
      }
      if (this.multiple && value1?.length && value2?.length && value1.length === value2.length) {
        for (const e1 of value1) {
          const test = value2.indexOf(e1) > -1;
          if (!test) {
            return true;
          }
        }
        return false;
      }
      return true;
    }
    updateFilteredData(writeValue = false) {
      setTimeout(() => {
        let result = this._data;
        if (this.multiple && this.hideSelectedItems) {
          result = Select2Utils.getFilteredSelectedData(result, this.option);
        }
        if (!this.customSearchEnabled && this.searchText && this.searchText.length >= +this.minCharForSearch) {
          result = Select2Utils.getFilteredData(result, this.searchText, this.editPattern);
        }
        if (this.maxResults > 0) {
          const data = Select2Utils.getReduceData(result, +this.maxResults);
          result = data.result;
          this.maxResultsExceeded = data.reduce;
        } else {
          this.maxResultsExceeded = false;
        }
        if (Select2Utils.valueIsNotInFilteredData(result, this.hoveringValue)) {
          this.hoveringValue = Select2Utils.getFirstAvailableOption(result);
        }
        if (writeValue && this._previousNativeValue !== this._value) {
          // refresh current selected value
          this.writeValue(this._control ? this._control.value : this._value);
        }
        this.filteredData = result;
        this._changeDetectorRef.markForCheck();
      });
    }
    clickExit() {
      this._focus(false);
    }
    ifParentContainsClass(element, cssClass) {
      return this.getParentElementByClass(element, cssClass) !== null;
    }
    ifParentContainsId(element, id) {
      return this.getParentElementById(element, id) !== null;
    }
    getParentElementByClass(element, cssClass) {
      return this.containClasses(element, cssClass.trim().split(/\s+/)) ? element : element.parentElement ? this.getParentElementByClass(element.parentElement, cssClass) : null;
    }
    getParentElementById(element, id) {
      return element.id === id ? element : element.parentElement ? this.getParentElementById(element.parentElement, id) : null;
    }
    containClasses(element, cssClasses) {
      if (!element.classList) {
        return false;
      }
      for (const cssClass of cssClasses) {
        if (!element.classList.contains(cssClass)) {
          return false;
        }
      }
      return true;
    }
    containAlmostOneClasses(element, cssClasses) {
      if (!element.classList) {
        return false;
      }
      let containAlmostOne = false;
      for (const cssClass of cssClasses) {
        if (element.classList.contains(cssClass)) {
          containAlmostOne = true;
        }
      }
      return containAlmostOne;
    }
    clickOnSelect2Element(element) {
      return this.containAlmostOneClasses(element, ['select2-overlay-backdrop', 'select2-label-content', 'select2-selection__rendered', 'select2-results__option']);
    }
    focusin() {
      if (!this.disabled) {
        this._focus(true);
      }
    }
    focusout() {
      if (this.selectionElement && !this.selectionElement.classList.contains('select2-focused')) {
        this._focus(false);
        this._onTouched();
      }
    }
    select(option, emit = true) {
      let value;
      if (option !== null && option !== undefined) {
        if (this.multiple) {
          const options = this.option;
          const index = options.findIndex(op => op.value === option.value);
          if (index === -1) {
            options.push(option);
          } else {
            options.splice(index, 1);
          }
          value = this.option.map(op => op.value);
        } else {
          this.option = option;
          if (this.isOpen) {
            this.isOpen = false;
            this.close.emit(this);
            this.selectionElement?.focus();
          }
          value = this.option.value;
          if (!option && this._value === null) {
            this._value = value ?? null;
          }
        }
      } else {
        // when remove value
        if (Array.isArray(this.option) ? this.option?.length : this.option) {
          value = '';
        }
        this.option = null;
      }
      if (this.multiple && this.hideSelectedItems) {
        this.updateFilteredData();
      }
      emit &&= value !== undefined && this.testDiffValue(this._value, value);
      if (this._control) {
        this._onChange(value);
      }
      if (emit) {
        this._value = value ?? null;
        setTimeout(() => {
          this.update.emit({
            component: this,
            value: this._value,
            options: Array.isArray(this.option) ? this.option : this.option ? [this.option] : null
          });
        });
      }
    }
    testDiffValue(val1, val2) {
      return Array.isArray(val1) ? val1?.length !== val2?.length : val1 !== val2;
    }
    keyDown(event, create = false) {
      if (create && this._testKey(event, ['Enter', 13])) {
        this.createAndAdd(event);
      } else if (this._testKey(event, ['ArrowDown', 40])) {
        this.moveDown();
        event.preventDefault();
      } else if (this._testKey(event, ['ArrowUp', 38])) {
        this.moveUp();
        event.preventDefault();
      } else if (this._testKey(event, ['Enter', 13])) {
        this.selectByEnter();
        event.preventDefault();
      } else if (this._testKey(event, ['Escape', 'Tab', 9, 27]) && this.isOpen) {
        this.toggleOpenAndClose();
        this._focus(false);
      }
    }
    openKey(event, create = false) {
      if (create && this._testKey(event, ['Enter', 13])) {
        this.createAndAdd(event);
      } else if (this._testKey(event, ['ArrowDown', 'ArrowUp', 'Enter', 40, 38, 13])) {
        this.toggleOpenAndClose(true, true, event);
        event.preventDefault();
      } else if (this._testKey(event, ['Escape', 'Tab', 9, 27])) {
        if (this.isOpen) {
          this.toggleOpenAndClose(false);
          this._onTouched();
          event.preventDefault();
        } else {
          this._focus(false);
        }
      }
    }
    searchUpdate(e) {
      this.searchText = e.target.value;
      if (!this.customSearchEnabled) {
        this.updateFilteredData();
      } else {
        this.search.emit({
          component: this,
          value: this._value,
          search: this.searchText,
          data: this._data,
          filteredData: data => {
            this.filteredData = data;
            this._changeDetectorRef.markForCheck();
          }
        });
      }
    }
    trackBy(_index, item) {
      return item.value;
    }
    isSelected(option) {
      return Select2Utils.isSelected(this.option, option, this.multiple);
    }
    isDisabled(option) {
      return option.disabled ? 'true' : 'false';
    }
    removeSelection(e, option) {
      Select2Utils.removeSelection(this.option, option);
      if (this.multiple && this.hideSelectedItems) {
        this.updateFilteredData();
      }
      const value = this.option.map(op => op.value);
      if (this._control) {
        this._onChange(value);
      } else {
        this._value = value ?? null;
      }
      this.update.emit({
        component: this,
        value: value,
        options: Array.isArray(this.option) ? this.option : this.option ? [this.option] : null
      });
      this.removeOption.emit({
        component: this,
        value: value,
        removedOption: option
      });
      e.preventDefault();
      e.stopPropagation();
      if (this.isOpen) {
        this._focusSearchboxOrResultsElement();
      }
    }
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param value
     */
    writeValue(value) {
      this._setSelectionByValue(value);
    }
    /**
     * Saves a callback function to be invoked when the select's value
     * changes from user input. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param fn Callback to be triggered when the value changes.
     */
    registerOnChange(fn) {
      this._onChange = fn;
    }
    /**
     * Saves a callback function to be invoked when the select is blurred
     * by the user. Part of the ControlValueAccessor interface required
     * to integrate with Angular's core forms API.
     *
     * @param fn Callback to be triggered when the component has been touched.
     */
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    /**
     * Sets whether the component should be disabled.
     * Implemented as part of ControlValueAccessor.
     * @param isDisabled
     */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    onScroll(way) {
      this.scroll.emit({
        component: this,
        way,
        search: this.innerSearchText,
        data: this._data
      });
    }
    _isErrorState() {
      const isInvalid = this._control?.invalid;
      const isTouched = this._control?.touched;
      const isSubmitted = this._parentFormGroup?.submitted || this._parentForm?.submitted;
      return !!(isInvalid && (isTouched || isSubmitted));
    }
    addItem(value) {
      let item = Select2Utils.getOptionByValue(this._data, value);
      if (!item) {
        item = {
          value,
          label: value
        };
        this._data.push(item);
      }
      return item;
    }
    createAndAdd(e) {
      const value = e.target.value;
      if (value.trim()) {
        const item = this.addItem(value.trim());
        this.click(item);
        e.target.value = '';
        this.autoCreateItem.emit({
          value: item,
          component: this,
          options: Array.isArray(this.option) ? this.option : this.option ? [this.option] : null
        });
      }
      this.stopEvent(e);
    }
    moveUp() {
      this.updateScrollFromOption(Select2Utils.getPreviousOption(this.filteredData, this.hoveringValue));
    }
    moveDown() {
      this.updateScrollFromOption(Select2Utils.getNextOption(this.filteredData, this.hoveringValue));
    }
    updateScrollFromOption(option) {
      if (option) {
        this.hoveringValue = option.value;
        const domElement = this.results.find(r => r.nativeElement.innerText.trim() === option.label);
        if (domElement && this.resultsElement) {
          this.resultsElement.scrollTop = 0;
          const listClientRect = this.resultsElement.getBoundingClientRect();
          const optionClientRect = domElement.nativeElement.getBoundingClientRect();
          this.resultsElement.scrollTop = optionClientRect.top - listClientRect.top;
        }
      }
    }
    selectByEnter() {
      if (this.hoveringValue) {
        const option = Select2Utils.getOptionByValue(this._data, this.hoveringValue);
        this.select(option);
      }
    }
    _testKey(event, refs = []) {
      return this._isKey(this._getKey(event), refs);
    }
    _getKey(event) {
      let code;
      if (event.key !== undefined) {
        code = event.key;
      } else if (event['keyIdentifier'] !== undefined) {
        code = event['keyIdentifier'];
      } else if (event['keyCode'] !== undefined) {
        code = event['keyCode'];
      } else {
        event.preventDefault();
      }
      return code;
    }
    _isKey(code, refs = []) {
      return refs && refs.length > 0 ? refs.indexOf(code) !== -1 : false;
    }
    /**
     * Sets the selected option based on a value. If no option can be
     * found with the designated value, the select trigger is cleared.
     */
    _setSelectionByValue(value) {
      if (this.option || value !== undefined && value !== null) {
        const isArray = Array.isArray(value);
        if (this.multiple && value && !isArray) {
          throw new Error('Non array value.');
        } else if (this._data) {
          if (this.multiple) {
            this.option = []; // if value is null, then empty option and return
            if (isArray) {
              // value is not null. Preselect value
              const selectedValues = Select2Utils.getOptionsByValue(this._data, value, this.multiple);
              selectedValues.map(item => this.select(item, false));
              this._value ??= value;
              if (this.testDiffValue(this._value, value)) {
                console.error(this.id, this._value, value);
                this.update.emit({
                  component: this,
                  value: value,
                  options: Array.isArray(this.option) ? this.option : this.option ? [this.option] : null
                });
              }
            } else if (value === null) {
              // fix if value is null
              this.value = [];
              this.reset();
              this.select(null, false);
              if (this.testDiffValue(this._value, value)) {
                this._value = [];
                this.update.emit({
                  component: this,
                  value: this._value,
                  options: Array.isArray(this.option) ? this.option : this.option ? [this.option] : null
                });
              }
            }
          } else {
            this._value ??= value;
            this.select(Select2Utils.getOptionByValue(this._data, value));
          }
        } else if (this._control) {
          this._control.viewToModelUpdate(value);
        }
        this._changeDetectorRef.markForCheck();
      }
    }
    /** Does some manual dirty checking on the native input `value` property. */
    _dirtyCheckNativeValue() {
      const newValue = this.value;
      if (this._previousNativeValue !== newValue) {
        this._previousNativeValue = newValue;
        this._stateChanges.next();
      }
    }
    _focusSearchboxOrResultsElement(focus = true) {
      if (!this.isSearchboxHidden) {
        setTimeout(() => {
          if (this.searchInput && this.searchInput.nativeElement && focus) {
            this.searchInput.nativeElement.focus();
          }
        });
        if (this.resultsElement && focus) {
          this.resultsElement.focus();
        }
      }
    }
    _focus(state) {
      if (!state && this.focused) {
        this.focused = state;
        this.blur.emit(this);
      } else if (state && !this.focused) {
        this.focused = state;
        this.focus.emit(this);
      }
    }
    _isAbobeOverlay() {
      return this.overlay && this._overlayPosition && this.listPosition === 'auto' ? this._overlayPosition === 'top' : this.listPosition === 'above';
    }
    /** @nocollapse */
    static {
      this.ɵfac = function Select2_Factory(t) {
        return new (t || Select2)(i0.ɵɵdirectiveInject(i1.ViewportRuler), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.NgForm, 8), i0.ɵɵdirectiveInject(i2.FormGroupDirective, 8), i0.ɵɵdirectiveInject(i2.NgControl, 10), i0.ɵɵinjectAttribute('tabindex'));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Select2,
        selectors: [["select2"]],
        viewQuery: function Select2_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(CdkConnectedOverlay, 5);
            i0.ɵɵviewQuery(_c0, 7);
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5);
            i0.ɵɵviewQuery(_c3, 5);
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cdkConnectedOverlay = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selection = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resultContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.results = _t);
          }
        },
        hostVars: 10,
        hostBindings: function Select2_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function Select2_click_HostBindingHandler($event) {
              return ctx.clickDetection($event);
            }, false, i0.ɵɵresolveDocument);
          }
          if (rf & 2) {
            i0.ɵɵhostProperty("id", ctx.id);
            i0.ɵɵattribute("aria-invalid", ctx.ariaInvalid);
            i0.ɵɵclassProp("material", ctx.classMaterial)("nostyle", ctx.classNostyle)("borderless", ctx.classBorderless)("select2-above", ctx.select2above);
          }
        },
        inputs: {
          data: "data",
          minCharForSearch: [2, "minCharForSearch", "minCharForSearch", numberAttribute],
          displaySearchStatus: "displaySearchStatus",
          placeholder: "placeholder",
          limitSelection: [2, "limitSelection", "limitSelection", numberAttribute],
          listPosition: "listPosition",
          multiple: [2, "multiple", "multiple", booleanAttribute],
          overlay: [2, "overlay", "overlay", booleanAttribute],
          styleMode: "styleMode",
          noResultMessage: "noResultMessage",
          maxResults: [2, "maxResults", "maxResults", numberAttribute],
          maxResultsMessage: "maxResultsMessage",
          infiniteScrollDistance: [2, "infiniteScrollDistance", "infiniteScrollDistance", numberAttribute],
          infiniteScrollThrottle: [2, "infiniteScrollThrottle", "infiniteScrollThrottle", numberAttribute],
          infiniteScroll: [2, "infiniteScroll", "infiniteScroll", booleanAttribute],
          autoCreate: [2, "autoCreate", "autoCreate", booleanAttribute],
          noLabelTemplate: [2, "noLabelTemplate", "noLabelTemplate", booleanAttribute],
          editPattern: "editPattern",
          templates: "templates",
          templateSelection: "templateSelection",
          resultMaxHeight: "resultMaxHeight",
          customSearchEnabled: [2, "customSearchEnabled", "customSearchEnabled", booleanAttribute],
          minCountForSearch: [2, "minCountForSearch", "minCountForSearch", numberAttribute],
          id: "id",
          required: [2, "required", "required", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          hideSelectedItems: [2, "hideSelectedItems", "hideSelectedItems", booleanAttribute],
          readonly: [2, "readonly", "readonly", booleanAttribute],
          value: "value",
          tabIndex: [2, "tabIndex", "tabIndex", numberAttribute],
          resettable: [2, "resettable", "resettable", booleanAttribute],
          resetSelectedValue: "resetSelectedValue",
          grid: "grid"
        },
        outputs: {
          update: "update",
          autoCreateItem: "autoCreateItem",
          open: "open",
          close: "close",
          focus: "focus",
          blur: "blur",
          search: "search",
          scroll: "scroll",
          removeOption: "removeOption"
        },
        features: [i0.ɵɵInputTransformsFeature],
        ngContentSelectors: _c6,
        decls: 18,
        vars: 28,
        consts: [["selection", "", "trigger", "cdkOverlayOrigin"], ["containerTemplate", ""], ["dropdown", ""], ["searchInput", ""], ["results", ""], ["result", ""], ["li", ""], [1, "select2-label", 3, "click"], [1, "select2-required"], [1, "select2", "select2-container", "select2-container--default"], ["cdkOverlayOrigin", "", 1, "selection", 3, "click", "focus", "blur", "keydown", "tabindex"], ["role", "combobox", 1, "select2-selection"], [1, "select2-selection__rendered", 3, "title"], ["role", "presentation", 1, "select2-selection__reset"], ["role", "presentation", 1, "select2-selection__arrow"], [1, "select2-selection__rendered"], [1, "select2-subscript-wrapper"], ["cdkConnectedOverlay", "", "cdkConnectedOverlayHasBackdrop", "", "cdkConnectedOverlayBackdropClass", "select2-overlay-backdrop", 3, "backdropClick", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayPositions"], [1, "select2-selection__placeholder"], [3, "innerHTML"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "presentation", 1, "select2-selection__reset", 3, "click"], [1, "select2-selection__placeholder", 3, "select2-selection__placeholder__option"], ["tabindex", "0", 1, "select2-selection__choice", 3, "title"], [1, "select2-selection__auto-create"], ["tabindex", "0", 1, "select2-selection__choice", 3, "keydown.enter", "title"], ["role", "presentation", 1, "select2-selection__choice__remove"], ["role", "presentation", 1, "select2-selection__choice__remove", 3, "click"], [1, "select2-selection__auto-create", 3, "focus", "blur"], ["type", "search", "role", "textbox", "autocomplete", "off", "autocorrect", "off", "autocapitalize", "off", "spellcheck", "false", 1, "select2-create__field", 3, "click", "keydown", "keyup", "change", "id"], [4, "ngTemplateOutlet"], [1, "select2-container", "select2-container--default", "select2-container-dropdown"], [1, "select2-dropdown"], [1, "select2-search", "select2-search--dropdown"], ["type", "search", "role", "textbox", "autocomplete", "off", "autocorrect", "off", "autocapitalize", "off", "spellcheck", "false", 1, "select2-search__field", 3, "keydown", "keyup", "change", "id", "value"], [1, "select2-results"], ["role", "tree", "tabindex", "-1", "infiniteScroll", "", 1, "select2-results__options", 3, "scrolled", "scrolledUp", "keydown", "infiniteScrollDisabled", "infiniteScrollDistance", "infiniteScrollThrottle", "infiniteScrollContainer"], [1, "select2-no-result", "select2-results__option", 3, "innerHTML"], [1, "select2-too-much-result", "select2-results__option", 3, "innerHTML"], ["role", "group", 1, "select2-results__option"], ["role", "treeitem", 3, "id", "class"], [1, "select2-results__options", "select2-results__options--nested"], ["role", "treeitem", 3, "mouseenter", "click", "id"], [1, "select2-label-content", 3, "innerHTML"]],
        template: function Select2_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵelementStart(0, "div", 7);
            i0.ɵɵlistener("click", function Select2_Template_div_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleOpenAndClose());
            });
            i0.ɵɵprojection(1);
            i0.ɵɵtemplate(2, Select2_Conditional_2_Template, 1, 0, "span", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 9)(4, "div", 10, 0);
            i0.ɵɵlistener("click", function Select2_Template_div_click_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleOpenAndClose());
            })("focus", function Select2_Template_div_focus_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.focusin());
            })("blur", function Select2_Template_div_blur_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.focusout());
            })("keydown", function Select2_Template_div_keydown_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.openKey($event));
            });
            i0.ɵɵelementStart(7, "div", 11);
            i0.ɵɵtemplate(8, Select2_Conditional_8_Template, 5, 6, "span", 12)(9, Select2_Conditional_9_Template, 2, 0, "span", 13)(10, Select2_Conditional_10_Template, 1, 0, "span", 14)(11, Select2_Conditional_11_Template, 5, 3, "ul", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, Select2_Conditional_12_Template, 1, 1, "ng-container");
            i0.ɵɵelementStart(13, "div", 16);
            i0.ɵɵprojection(14, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(15, Select2_ng_template_15_Template, 1, 1, "ng-template", 17);
            i0.ɵɵlistener("backdropClick", function Select2_Template_ng_template_backdropClick_15_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleOpenAndClose());
            });
            i0.ɵɵtemplate(16, Select2_ng_template_16_Template, 13, 31, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const trigger_r18 = i0.ɵɵreference(6);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.required ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("select2-container--focus", ctx.focused)("select2-container--below", !ctx.select2above)("select2-container--above", ctx.select2above)("select2-container--open", ctx.isOpen)("select2-container--disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("select2-focused", ctx.focused);
            i0.ɵɵproperty("tabindex", !ctx.isOpen ? ctx.tabIndex : "-1");
            i0.ɵɵadvance(3);
            i0.ɵɵclassProp("select2-selection--multiple", ctx.multiple)("select2-selection--single", !ctx.multiple);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.multiple ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.multiple && ctx.resettable && ctx.resetSelectedValue !== ctx.value && ctx.select2Option && !(ctx.disabled || ctx.readonly) ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.multiple ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.multiple ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.overlay ? 12 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cdkConnectedOverlayOrigin", trigger_r18)("cdkConnectedOverlayOpen", ctx.isOpen && ctx.overlay)("cdkConnectedOverlayMinWidth", ctx.overlayWidth)("cdkConnectedOverlayHeight", ctx.overlayHeight)("cdkConnectedOverlayPositions", ctx._positions);
          }
        },
        dependencies: [i3.NgTemplateOutlet, i4.CdkConnectedOverlay, i4.CdkOverlayOrigin, i5.InfiniteScrollDirective],
        styles: [".select2-label[_ngcontent-%COMP%]{color:var(--select2-label-text-color, #000)}.select2-container[_ngcontent-%COMP%]{box-sizing:border-box;display:inline-block;margin:0;position:relative;vertical-align:middle;width:100%}.select2-container[_ngcontent-%COMP%]   .select2-container-dropdown[_ngcontent-%COMP%]{position:absolute;width:0px;opacity:0}.select2-container[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]{box-sizing:border-box;cursor:pointer;display:block;height:var(--select2-single-height, 28px);-webkit-user-select:none;user-select:none}.select2-container[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]{display:block;padding:var(--select2-selection-padding, 0 0 0 8px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1 1 auto}.select2-container[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__clear[_ngcontent-%COMP%]{position:relative}.select2-container[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{box-sizing:border-box;cursor:pointer;display:block;min-height:var(--select2-multiple-height, 28px);-webkit-user-select:none;user-select:none}.select2-container[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]{display:inline-flex;overflow:hidden;padding-left:8px;padding-bottom:2px;text-overflow:ellipsis;white-space:nowrap;flex-wrap:wrap;gap:var(--select2-selection-multiple-gap, 2px 5px)}.select2-container[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]   .select2-selection__auto-create[_ngcontent-%COMP%]{flex:1 1 150px;min-width:150px;display:flex}.select2-container[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]   .select2-create__field[_ngcontent-%COMP%]{width:100%;border:0}.select2-container[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]   .select2-create__field[_ngcontent-%COMP%]:focus{border:0;outline:0}.select2-container[_ngcontent-%COMP%]   .select2-search--inline[_ngcontent-%COMP%]{float:left}.select2-container[_ngcontent-%COMP%]   .select2-search--inline[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%]{box-sizing:border-box;border:none;font-size:100%;margin-top:5px;padding:0}.select2-container[_ngcontent-%COMP%]   .select2-search--inline[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%]::-webkit-search-cancel-button{-webkit-appearance:none}.select2-dropdown[_ngcontent-%COMP%]{background:var(--select2-dropdown-background, white);border:1px solid var(--select2-dropdown-border-color, #aaa);border-radius:var(--select2-selection-border-radius, 4px);box-sizing:border-box;display:block;position:absolute;width:100%;z-index:1051;height:0;overflow:hidden}.select2-dropdown[_ngcontent-%COMP%]   .select2-label-content[_ngcontent-%COMP%]{display:contents}.select2-results[_ngcontent-%COMP%]{display:block}.select2-results__options[_ngcontent-%COMP%]{list-style:none;margin:0;padding:0}.select2-results__option[_ngcontent-%COMP%]{padding:var(--select2-option-padding, 6px);-webkit-user-select:none;user-select:none;color:var(--select2-option-text-color, #000)}.select2-results__option[aria-selected][_ngcontent-%COMP%]{cursor:pointer}.select2-container.select2-container-dropdown.select2-container--open[_ngcontent-%COMP%]{width:100%;opacity:1}.select2-container--open[_ngcontent-%COMP%]   .select2-dropdown[_ngcontent-%COMP%]{overflow:auto;height:auto}.select2-container--open[_ngcontent-%COMP%]   .select2-dropdown--above[_ngcontent-%COMP%]{border-bottom:var(--select2-dropdown-above-border-bottom, none);border-bottom-left-radius:var(--select2-dropdown-above-border-bottom-left-radius, 0);border-bottom-right-radius:var(--select2-dropdown-above-border-bottom-right-radius, 0);bottom:27px;display:flex;flex-direction:column-reverse}.select2-container--open[_ngcontent-%COMP%]   .select2-dropdown--below[_ngcontent-%COMP%]{border-top:var(--select2-dropdown-below-border-top, none);border-top-left-radius:var(--select2-dropdown-below-border-top-left-radius, 0);border-top-right-radius:var(--select2-dropdown-below-border-top-right-radius, 0)}.select2-search--dropdown[_ngcontent-%COMP%]{display:block;padding:4px}.select2-search--dropdown[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%]{padding:4px;width:100%;box-sizing:border-box}.select2-search--dropdown[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%]::-webkit-search-cancel-button{-webkit-appearance:none}.select2-search--dropdown.select2-search--hide[_ngcontent-%COMP%]{display:none}.select2-close-mask[_ngcontent-%COMP%]{border:0;margin:0;padding:0;display:block;position:fixed;left:0;top:0;min-height:100%;min-width:100%;height:auto;width:auto;opacity:0;z-index:99}.select2-required[_ngcontent-%COMP%]:before{content:\"*\";color:var(--select2-required-color, red)}.select2-hidden-accessible[_ngcontent-%COMP%]{border:0!important;clip:rect(0 0 0 0)!important;height:1px!important;margin:-1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;width:1px!important}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]{background:var(--select2-selection-background, #fff);border:1px solid var(--select2-selection-border-color, #aaa);border-radius:var(--select2-selection-border-radius, 4px);display:flex}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]{color:var(--select2-selection-text-color, #111);line-height:var(--select2-selection-line-height, 28px)}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__clear[_ngcontent-%COMP%]{cursor:pointer;float:right;font-weight:700}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__placeholder[_ngcontent-%COMP%]{color:var(--select2-placeholder-color, #999)}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__placeholder[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;text-overflow:var(--select2-placeholder-overflow, ellipsis)}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__placeholder__option[_ngcontent-%COMP%]{display:none}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__reset[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__arrow[_ngcontent-%COMP%]{display:flex;width:20px;align-items:center;justify-content:center}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__arrow[_ngcontent-%COMP%]:before{content:\" \";border-color:var(--select2-arrow-color, #888) transparent;border-style:solid;border-width:5px 4px 0;height:0;width:0}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__reset[_ngcontent-%COMP%]{color:var(--select2-reset-color, #999)}.select2-container--default.select2-container--disabled[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]{background:var(--select2-selection-disabled-background, #eee);cursor:default}.select2-container--default.select2-container--disabled[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__clear[_ngcontent-%COMP%]{display:none}.select2-container--default.select2-container--open[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__arrow[_ngcontent-%COMP%]:before{border-color:transparent transparent var(--select2-arrow-color, #888);border-width:0 4px 5px}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{background:var(--select2-selection-background, #fff);border:1px solid var(--select2-selection-border-color, #aaa);border-radius:var(--select2-selection-border-radius, 4px);cursor:text;display:flex}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]{flex:1 1 auto;box-sizing:border-box;list-style:none;margin:0;padding:var(--select2-selection-multiple-padding, 2px 5px);width:100%;min-height:1em;align-items:center}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style:none;line-height:var(--select2-selection-choice-line-height, 20px)}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__placeholder[_ngcontent-%COMP%]{display:block;width:100%;color:var(--select2-placeholder-color, #999);margin-top:5px;float:left;overflow:hidden;white-space:nowrap;text-overflow:var(--select2-placeholder-overflow, ellipsis)}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__placeholder__option[_ngcontent-%COMP%]{display:none}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__clear[_ngcontent-%COMP%]{cursor:pointer;float:right;font-weight:700;margin-top:5px;margin-right:10px}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__choice[_ngcontent-%COMP%]{color:var(--select2-selection-choice-text-color, #000);background:var(--select2-selection-choice-background, #e4e4e4);border:1px solid var(--select2-selection-choice-border-color, #aaa);border-radius:var(--select2-selection-border-radius, 4px);cursor:default;padding:0 5px}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__choice__remove[_ngcontent-%COMP%]{color:var(--select2-selection-choice-close-color, #999);cursor:pointer;display:inline-block;font-weight:700;margin-right:2px}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__choice__remove[_ngcontent-%COMP%]:hover{color:var(--select2-selection-choice-hover-close-color, #333)}.select2-container--default.select2-container--focused[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{border:solid var(--select2-selection-focus-border-color, #000) 1px;outline:none}.select2-container--default[_ngcontent-%COMP%]:not(.select2-container--open)   .select2-focused[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]:not(.select2-container--open)   .select2-focused[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{border:solid var(--select2-selection-focus-border-color, #000) 1px;outline:none}.select2-container--default.select2-container--disabled[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{background:var(--select2-selection-disabled-background, #eee);cursor:default}.select2-container--default.select2-container--disabled[_ngcontent-%COMP%]   .select2-selection__choice__remove[_ngcontent-%COMP%]{display:none}.select2-container--default.select2-container--open.select2-container--above[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .select2-container--default.select2-container--open.select2-container--above[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{border-top-left-radius:0;border-top-right-radius:0}.select2-container--default.select2-container--open.select2-container--below[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .select2-container--default.select2-container--open.select2-container--below[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-bottom-right-radius:0}.select2-container--default[_ngcontent-%COMP%]   .select2-search--dropdown[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%]{border:1px solid var(--select2-search-border-color, #aaa);background:1px solid var(--select2-search-background, #fff);border-radius:var(--select2-search-border-radius, 0px)}.select2-container--default[_ngcontent-%COMP%]   .select2-search--inline[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%]{background:transparent;border:none;outline:none;box-shadow:none;-webkit-appearance:textfield}.select2-container--default[_ngcontent-%COMP%]   .select2-results[_ngcontent-%COMP%] > .select2-results__options[_ngcontent-%COMP%]{overflow-y:auto}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[role=group][_ngcontent-%COMP%]{padding:0;grid-column:col-start/col-end}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[aria-disabled=true][_ngcontent-%COMP%]{color:var(--select2-option-disabled-text-color, #999);background:var(--select2-option-disabled-background, transparent)}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[aria-selected=true][_ngcontent-%COMP%]{color:var(--select2-option-selected-text-color, #000);background:var(--select2-option-selected-background, #ddd)}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]{padding-left:1em}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__group[_ngcontent-%COMP%]{padding-left:0}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]{margin-left:-1em;padding-left:2em}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]{margin-left:-2em;padding-left:3em}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]{margin-left:-3em;padding-left:4em}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]{margin-left:-4em;padding-left:5em}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]{margin-left:-5em;padding-left:6em}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option--highlighted[aria-selected][_ngcontent-%COMP%]{background:var(--select2-option-highlighted-background, #5897fb);color:var(--select2-option-highlighted-text-color, #fff)}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option--hide[_ngcontent-%COMP%]{display:none}.select2-container--default[_ngcontent-%COMP%]   .select2-results__group[_ngcontent-%COMP%]{cursor:default;display:block;padding:6px;color:var(--select2-option-group-text-color, gray);background:var(--select2-option-group-background, transparent)}.select2-no-result[_ngcontent-%COMP%]{color:var(--select2-no-result-color, #888);font-style:var(--select2-no-result-font-style, italic)}.select2-too-much-result[_ngcontent-%COMP%]{color:var(--select2-too-much-result-color, #888);font-style:var(--select2-too-much-font-style, italic)}.select2-grid[_ngcontent-%COMP%], .select2-grid[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{display:grid;grid-template-columns:[col-start] repeat(var(--grid-size),1fr) [col-end]}.select2-grid-auto[_ngcontent-%COMP%], .select2-grid-auto[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{display:grid;grid-template-columns:[col-start] repeat(auto-fill,minmax(var(--grid-size, 100px),1fr)) [col-end]}.select2-container--default[_ngcontent-%COMP%]   .select2-grid[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid-auto[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding-left:var(--select2-option-padding, 6px)}.select2-container--default[_ngcontent-%COMP%]   .select2-grid[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__group[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid-auto[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__group[_ngcontent-%COMP%]{padding-left:0}.select2-container--default[_ngcontent-%COMP%]   .select2-grid[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid-auto[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid-auto[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid-auto[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid-auto[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-grid-auto[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]   .select2-results__option[_ngcontent-%COMP%]{padding-left:var(--select2-option-padding, 6px)}.nostyle[_nghost-%COMP%]   .select2-dropdown[_ngcontent-%COMP%]{border-color:transparent}.nostyle[_nghost-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .nostyle[_nghost-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{background:transparent;border-color:transparent}.nostyle[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-focused[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .nostyle[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-focused[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%], .nostyle[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]:not(.select2-container--open)   .select2-focused[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .nostyle[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]:not(.select2-container--open)   .select2-focused[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{background:transparent;border-color:transparent}.borderless[_nghost-%COMP%]{--select2-dropdown-above-border-bottom: 1px solid var(--select2-dropdown-border-color, #aaa);--select2-dropdown-above-border-bottom-left-radius: var(--select2-selection-border-radius, 4px);--select2-dropdown-above-border-bottom-right-radius: var(--select2-selection-border-radius, 4px);--select2-dropdown-below-border-top: 1px solid var(--select2-dropdown-border-color, #aaa);--select2-dropdown-below-border-top-left-radius: var(--select2-selection-border-radius, 4px);--select2-dropdown-below-border-top-right-radius: var(--select2-selection-border-radius, 4px)}.borderless[_nghost-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .borderless[_nghost-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{background:transparent;border-color:transparent}.borderless[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-focused[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .borderless[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-focused[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%], .borderless[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]:not(.select2-container--open)   .select2-focused[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .borderless[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]:not(.select2-container--open)   .select2-focused[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{background:transparent;border-color:transparent}.material[_nghost-%COMP%]{display:inline-block;width:300px}.material[_nghost-%COMP%] > .select2-container[_ngcontent-%COMP%]{padding-bottom:1.29688em;vertical-align:inherit}.material[_nghost-%COMP%] > .select2-container[_ngcontent-%COMP%]   .selection[_ngcontent-%COMP%]{padding:.4375em 0;border-top:.84375em solid transparent;display:inline-flex;align-items:baseline;width:100%;height:auto}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{width:100%;border:0;border-radius:0;height:24px;box-sizing:border-box}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]:before, .material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]:before{content:\" \";display:block;position:absolute;bottom:1.65em;background:var(--select2-material-underline, #ddd);height:1px;width:100%}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]:after, .material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]:after{content:\" \";display:block;position:absolute;bottom:1.63em;background:var(--select2-material-underline-active, #5a419e);height:2px;width:0%;left:50%;transition:none}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%], .material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]{padding-left:1px;line-height:inherit}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__placeholder[_ngcontent-%COMP%], .material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__placeholder[_ngcontent-%COMP%]{display:block;color:var(--select2-material-placeholder-color, rgba(0, 0, 0, .38));transition:transform .3s;position:absolute;transform-origin:0 21px;left:0;top:20px}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-container--open[_ngcontent-%COMP%]{left:0;bottom:1.6em}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection__placeholder__option[_ngcontent-%COMP%]{transform:translateY(-1.5em) scale(.75) perspective(100px) translateZ(.001px);width:133.33333%}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection__arrow[_ngcontent-%COMP%]{top:20px}.material[_nghost-%COMP%]   .select2-container--default.select2-container--open[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]:after, .material[_nghost-%COMP%]   .select2-container--default.select2-container--open[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]:after, .material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-focused[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]:after, .material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-focused[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]:after{transition:width .3s cubic-bezier(.12,1,.77,1),left .3s cubic-bezier(.12,1,.77,1);width:100%;left:0%}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-dropdown[_ngcontent-%COMP%]{border-radius:0;border:0;box-shadow:0 5px 5px #00000080}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-results__option[aria-selected=true][_ngcontent-%COMP%], .material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-results__option--highlighted[aria-selected][_ngcontent-%COMP%]{background:var(--select2-material-option-selected-background, rgba(0, 0, 0, .04));color:var(--select2-material-option-highlighted-text-color, #000)}.material[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-results__option[aria-selected=true][_ngcontent-%COMP%]{color:var(--select2-material-option-selected-text-color, #ff5722)}.material[_nghost-%COMP%]   .select2-container--default.select2-container--disabled[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .material[_nghost-%COMP%]   .select2-container--default.select2-container--disabled[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{background:transparent}.material[_nghost-%COMP%]   .select2-container--default.select2-container--disabled[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]:before, .material[_nghost-%COMP%]   .select2-container--default.select2-container--disabled[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]:before{background:var(--select2-material-underline-disabled, linear-gradient(to right, rgba(0, 0, 0, .26) 0, rgba(0, 0, 0, .26) 33%, transparent 0));background-size:4px 1px;background-repeat:repeat-x;background-position:0 bottom}.material.ng-invalid.ng-touched[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]:before, .material.ng-invalid.ng-touched[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]:after, .material.ng-invalid.ng-touched[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]:before, .material.ng-invalid.ng-touched[_nghost-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]:after{background:var(--select2-material-underline-invalid, red)}.material[_nghost-%COMP%]:not(.select2-container--open)   .select2-focused[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .material[_nghost-%COMP%]:not(.select2-container--open)   .select2-focused[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{border:0}.material[_nghost-%COMP%]   .select2-subscript-wrapper[_ngcontent-%COMP%]{position:absolute;top:calc(100% - 1.72917em);font-size:75%;color:var(--select2-hint-text-color, #888)}  .select2-overlay-backdrop{background:var(--select2-overlay-backdrop, transparent)}  .cdk-overlay-container .select2-container .select2-dropdown.select2-dropdown--above{bottom:28px}  .cdk-overlay-container .select2-container--open.select2-position-auto .select2-dropdown{margin-bottom:28px}  .cdk-overlay-container .select2-container--open.select2-position-auto .select2-dropdown.select2-dropdown--above{bottom:0;margin-bottom:0;margin-top:28px}  .cdk-overlay-container .select2-style-borderless{--select2-dropdown-above-border-bottom: 1px solid var(--select2-dropdown-border-color, #aaa);--select2-dropdown-above-border-bottom-left-radius: var(--select2-selection-border-radius, 4px);--select2-dropdown-above-border-bottom-right-radius: var(--select2-selection-border-radius, 4px);--select2-dropdown-below-border-top: 1px solid var(--select2-dropdown-border-color, #aaa);--select2-dropdown-below-border-top-left-radius: var(--select2-selection-border-radius, 4px);--select2-dropdown-below-border-top-right-radius: var(--select2-selection-border-radius, 4px)}@supports (-moz-appearance: none){select2.material[_ngcontent-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], select2.material[_ngcontent-%COMP%]   .select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{height:26px}}"]
      });
    }
  }
  return Select2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Select2Hint = /*#__PURE__*/(() => {
  class Select2Hint {
    /** @nocollapse */static {
      this.ɵfac = function Select2Hint_Factory(t) {
        return new (t || Select2Hint)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Select2Hint,
        selectors: [["select2-hint"]]
      });
    }
  }
  return Select2Hint;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Select2Label = /*#__PURE__*/(() => {
  class Select2Label {
    /** @nocollapse */static {
      this.ɵfac = function Select2Label_Factory(t) {
        return new (t || Select2Label)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Select2Label,
        selectors: [["select2-label"]]
      });
    }
  }
  return Select2Label;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Select2Module = /*#__PURE__*/(() => {
  class Select2Module {
    /** @nocollapse */static {
      this.ɵfac = function Select2Module_Factory(t) {
        return new (t || Select2Module)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Select2Module
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, OverlayModule, ReactiveFormsModule, InfiniteScrollModule, FormsModule, ReactiveFormsModule]
      });
    }
  }
  return Select2Module;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ng-select2-component
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Select2, Select2Hint, Select2Label, Select2Module, Select2Utils, defaultMinCountForSearch, protectRegexp, timeout, unicodePatterns };
